<template>
  <v-app light>
    <app-header></app-header>
    <router-view></router-view>
  </v-app>
</template>

<script>
  import Header from '@/components/modules/Header';

  export default {
    name: 'app',
    components: {
      appHeader: Header,
    },
    created() {
      const role = this.$cookie.get('role');
      if (!isNaN(role)) {
        this.$store.dispatch('setRole', parseInt(role, 10));
      }
    },
  };
</script>

<style>
  [v-cloak] {
    display: none;
  }
  a {
    text-decoration: none;
  }
  .application.theme--light {
    background: #fff !important;
  }

  .application .theme--light.card, .theme--light .card, .application .theme--light.list, .theme--light .list {
    background-color: #f1f1f1 !important;
  }
  .application .dialog .theme--dark.btn.btn--disabled:not(.btn--icon):not(.btn--flat), .dialog .theme--dark .btn.btn--disabled:not(.btn--icon):not(.btn--flat) {
    background-color: rgba(0,0,0,.12)!important;
  }

  .toolbar__title {
    height: 78px;
    padding: 10px 0;
    margin-left: 0 !important;
  }
  .toolbar__title:hover {
    cursor: pointer;
  }
  .toolbar__title span {
    display: block;
    font-size: 14px;
    opacity: 0.8;
  }
  .nav-icons {
    margin-right: 10px;
  }
  h3 {
    text-transform: uppercase;
  }
  .checkbox .input-group__details,
  .radio-group .input-group__details {
    display: none !important;
  }
  table tbody td {
    font-size: 11px !important;
  }
  .vertical-align {
    align-items: center !important;
  }
  .logo-img {
    width: auto;
    margin: 3px auto 0;
    overflow: hidden;
    height: 30px;
    position: relative;
  }
  .logo-img img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: auto;
    max-width: 100%;
    height: 100%;
  }
  .pt-0 main {
    padding: 0 !important;
  }

  .td-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end !important;
  }


  .vdatetime-popup__header {
    background: #00838f !important;
  }
  .vdatetime-calendar__month__day--selected > span > span, 
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #00838f !important;
  }
  .vdatetime-popup__actions__button {
    color: #00838f !important;
  }
  .vdatetime-input {
    cursor: pointer;
  }
  .vdatetime-time-picker__item--selected {
    color:#00838f !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue